// extracted by mini-css-extract-plugin
export var spin = "Loading-module--spin--56e12";
export var spinner = "Loading-module--spinner--1f244";